// Angular modules
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, withFetch } from '@angular/common/http';
import { withInterceptorsFromDi } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { ApplicationConfig, provideAppInitializer, inject } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { withInMemoryScrolling } from '@angular/router';
import { withRouterConfig } from '@angular/router';

// External modules
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularSvgIconModule } from 'angular-svg-icon';

// Internal modules
import { environment } from '@env/environment';
import { routes } from './app.routes';
import { LANGUAGE_STORAGE_KEY } from '@blocks/language-switcher/language-switcher.component';

// Services
import { AppService } from '@services/app.service';
import { StoreService } from '@services/store.service';
import { InstanceService } from './shared/services/instance.service';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [

    // Routing
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled'
      }),
    ),

    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en',
      lang: localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? environment.defaultLanguage
    }),

    importProvidersFrom(
      // Angular modules
      BrowserModule,

      // External modules
      AngularSvgIconModule.forRoot(),

      // Internal modules
    ),

    // External modules

    // Services
    StoreService,
    AppService,

    // Pipes
    DatePipe,

    // Guards

    // Resolvers
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimations(),
    provideClientHydration(),
    provideAppInitializer(() => {
      const instanceService = inject(InstanceService);
      return instanceService.load();
    }),

  ]
};